var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgECommerce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 799.949,
    height: 573.828,
    viewBox: "0 0 799.949 573.828",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-520.438 -224.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.541,
    height: 16.603,
    transform: "translate(1165.727 768.204)",
    fill: "#e49497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.286,432.384A4.1,4.1,0,0,0,175,429.5a5.283,5.283,0,0,0-1.773-3.811c-.027-.381-.417-5.14-1.294-5.991a4.148,4.148,0,0,0-.213-3.04,2.134,2.134,0,0,0-1.64-.9h-.035l-.018.027c-.018.035-2.136,3.714-5.318,4.033-1.826.186-3.652-.753-5.433-2.792-.062-.151-.567-2.632-.9-4.272V412.7l-17.363,9.12-10.139,2.81a2.95,2.95,0,0,0-.487,5.5l4.919,2.366a15.429,15.429,0,0,0,6.621,1.507H168.6a7.445,7.445,0,0,0,4.68-1.622Z",
    transform: "translate(1007.526 362.217)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.584,
    height: 11.584,
    transform: "matrix(0.805, -0.593, 0.593, 0.805, 1296.74, 766.98)",
    fill: "#e49497"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.715,392.628a3.782,3.782,0,0,0-.3-3.086,4.854,4.854,0,0,0-3.406-1.858c-.229-.27-3.127-3.586-4.241-3.741a3.806,3.806,0,0,0-1.817-2.145,1.953,1.953,0,0,0-1.711.237l-.025.016v.033s.45,3.93-1.744,5.919c-1.253,1.138-3.127,1.441-5.567.9-.131-.074-1.867-1.646-3-2.693l-.049-.041-7.9,16.292-6,7.646a2.727,2.727,0,0,0-.049,3.3,2.757,2.757,0,0,0,2.7,1.064l4.953-.941a14.282,14.282,0,0,0,5.755-2.505L52.136,396.41a6.909,6.909,0,0,0,2.6-3.774Z",
    transform: "translate(1265.489 382.685)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520.438 224.258)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H585.859V369.758a5.452,5.452,0,0,1-5.452,5.452H5.452A5.452,5.452,0,0,1,0,369.758Z",
    transform: "translate(0.25 0.332)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.635,0H548.719a3.635,3.635,0,0,1,3.635,3.635V302.317a3.635,3.635,0,0,1-3.635,3.635H3.635A3.635,3.635,0,0,1,0,302.317V3.635A3.635,3.635,0,0,1,3.635,0Z",
    transform: "translate(17.003 47.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.452,0H580.407a5.452,5.452,0,0,1,5.452,5.452V24.889H0V5.452A5.452,5.452,0,0,1,5.452,0Z",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.613,0A4.613,4.613,0,1,1,0,4.613,4.613,4.613,0,0,1,4.613,0Z",
    transform: "translate(13.883 8.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.613,0A4.613,4.613,0,1,1,0,4.613,4.613,4.613,0,0,1,4.613,0Z",
    transform: "translate(31.393 8.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.613,0A4.613,4.613,0,1,1,0,4.613,4.613,4.613,0,0,1,4.613,0Z",
    transform: "translate(48.903 8.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.635,0H104.4a3.635,3.635,0,0,1,3.635,3.635V113.571a3.635,3.635,0,0,1-3.635,3.635H3.635A3.635,3.635,0,0,1,0,113.571V3.635A3.635,3.635,0,0,1,3.635,0Z",
    transform: "translate(84.963 72.557)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.635,0H104.4a3.635,3.635,0,0,1,3.635,3.635V113.571a3.635,3.635,0,0,1-3.635,3.635H3.635A3.635,3.635,0,0,1,0,113.571V3.635A3.635,3.635,0,0,1,3.635,0Z",
    transform: "translate(239.163 72.557)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.635,0H104.4a3.635,3.635,0,0,1,3.635,3.635V113.571a3.635,3.635,0,0,1-3.635,3.635H3.635A3.635,3.635,0,0,1,0,113.571V3.635A3.635,3.635,0,0,1,3.635,0Z",
    transform: "translate(393.361 72.557)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.635,0H104.4a3.635,3.635,0,0,1,3.635,3.635V113.571a3.635,3.635,0,0,1-3.635,3.635H3.635A3.635,3.635,0,0,1,0,113.571V3.635A3.635,3.635,0,0,1,3.635,0Z",
    transform: "translate(84.963 210.977)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.635,0H104.4a3.635,3.635,0,0,1,3.635,3.635V113.571a3.635,3.635,0,0,1-3.635,3.635H3.635A3.635,3.635,0,0,1,0,113.571V3.635A3.635,3.635,0,0,1,3.635,0Z",
    transform: "translate(239.163 210.977)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.635,0H104.4a3.635,3.635,0,0,1,3.635,3.635V113.571a3.635,3.635,0,0,1-3.635,3.635H3.635A3.635,3.635,0,0,1,0,113.571V3.635A3.635,3.635,0,0,1,3.635,0Z",
    transform: "translate(393.361 210.977)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.257,398.8l19.739-7.8,2.3,39.019s4.131,11.935,2.754,16.526c0,0,.918,7.8-1.378,8.263s-8.723,1.378-9.178.918-.459-1.836-.459-1.836-4.591,3.213-5.05,6.885c0,0-19.28,5.967-19.739.459s9.639-10.1,9.639-10.1l7.8-11.935Z",
    transform: "translate(-185.983 -157.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.229,398.8l19.736-7.8,2.3,39.019s4.131,11.935,2.754,16.526c0,0,.918,7.8-1.378,8.263s-8.723,1.378-9.178.918-.459-1.836-.459-1.836-4.591,3.213-5.05,6.885c0,0-19.28,5.967-19.739.459s9.639-10.1,9.639-10.1l7.8-11.935Z",
    transform: "translate(-190.18 -157.699)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.516,233.611s-4.2,11.744.667,17.04l-4.06,13.951s14.425,43.274,10.3,49.319c0,0-15.386,7.693-46.162-2.748l12.5-48.494-1.786-20.469,2.473-9.617,5.495-.545s-3.3,12.364,2.748,14.287,11.941-13.978,11.941-13.978Z",
    transform: "translate(-187.539 -143.186)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.858,309.346l5.3,2.17,25.314-33.27,7.956,39.056,5.3-.964c3.4-33.672,6.179-68.016,2.772-84.26l-19.649-.844-8.92,28.452-4.34,19.287Z",
    transform: "translate(-171.98 -143.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.422,231.87s-7.239,10.063-6.885,14.124,4.943,70.267,4.943,70.267l10.77.53-3.18-47.668,2.648-12.888,6.533,60.027,13.242.353-11.829-77.858-2.3-6.885Z",
    transform: "translate(-203.632 -143.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.336,409.368c-1.922-2.306-5.226-3.553-8.4-4.227.091-.288-9.649-2.3-9.814-1.886l-3.672-2.925-11.283,5.858-6.34-4.316-2.945,1.045c.12-.52-9.142,1.085-9.142,1.085-1.769.064-4.029.174-6.559.369-8.859.682-9.541,23.626-9.541,23.626a36.213,36.213,0,0,1,12.824-2.685l2.394,27.443c12.316-1.056,25.232.173,38.62,3.18l6.278-21.572,14.62-5.686S683.879,414.819,679.336,409.368Z",
    transform: "translate(-201.634 -158.551)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.274,395.147c-1.584-1.9-4.305-2.928-6.92-3.483.078-.238-7.95-1.9-8.087-1.554l-3.026-2.41-9.3,4.827-5.224-3.556-2.426.861c.1-.428-7.533.893-7.533.893-1.454.053-3.32.144-5.4.3-7.3.562-7.861,19.465-7.861,19.465a29.838,29.838,0,0,1,10.567-2.213l1.973,55.352a104.6,104.6,0,0,1,31.818,2.621l5.172-50.514,12.047-4.684S339.017,399.64,335.274,395.147Z",
    transform: "translate(-171.308 -157.398)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M909.888,406.722h51.8V379.007a25.9,25.9,0,1,0-51.8,0Z",
    transform: "translate(291.573 70.018)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.609,535.111l.86,4.3s2.579,2.579,1.289,3.868-.86,7.308-.86,7.308c.721,10.973,15.06,72.638,17.624,84.681,0,0,19.773,12.9,35.247,38.256s15.9,31.809,15.9,31.809l-17.191,7.309L954.5,660.627s-12.036-7.308-16.335-13.755S907.212,573.8,907.212,573.8l-15.048,69.636s.86,25.361-3.009,41.7a174.944,174.944,0,0,0-4.3,31.379l-20.2-2.149s1.289-61.039,3.439-67.487c0,0-9.027-74.364,9.027-104.024l14.55-38.79,14.25-5.485Z",
    transform: "translate(295.703 56.737)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.73,0H18.382L20.9,23.626H0Z",
    transform: "translate(1217.01 467.554)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.638,360.565c-27.122.463-27.117,40.807,0,41.266C963.758,401.367,963.754,361.024,936.638,360.565Z",
    transform: "translate(290.987 69.337)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.711,379.63h4.61l1.255-3.139-.628,3.139h25.212l-.818-6.567,6.128,6.567h6.113v-3.558a20.935,20.935,0,1,0-41.869-.03v.03Z",
    transform: "translate(291.041 69.834)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.939,419.194l37.876-.4,13.375.819L946.362,529.486s-59.937-3.163-59.974-21.458L892,491.771Z",
    transform: "translate(293.718 64.021)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.535,548.641a8.521,8.521,0,0,1,2.454-12.833l-2.227-19.343,11.425-4.221,2.762,27.362a8.567,8.567,0,0,1-14.413,9.035Z",
    transform: "translate(286.576 55.489)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.248,429.156l6.743-9.426s4.615-1.024,10.067,5.337,8.633,85.872,8.633,85.872L961.7,515.482l-11.813-56.339Z",
    transform: "translate(287.921 63.941)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.135,389.525l1.487,70.639,45.73,24.167,83.28-14.872,2.045-73.428-52.794-18.59Z",
    transform: "translate(459.069 189.796)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.6,619.276l-46.332-24.484-1.51-71.711,80.563-12.207.172.06,53.3,18.767-2.076,74.555ZM834.705,593.9l45.128,23.848,82.448-14.723,2.013-72.3-52.12-18.352-78.935,11.96Z",
    transform: "translate(298.707 55.614)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.3,409.823l-.179-.071-46.287-18.4.539-1.357,46.109,18.332,86.065-11.87.2,1.447Z",
    transform: "translate(459.097 188.65)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.461,
    height: 76.408,
    transform: "translate(1176.763 597.737) rotate(-0.697)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.859,405.826l-16.685-6.764,80.324-12.8,16.686,6.763Z",
    transform: "translate(456.692 188.991)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.461,
    height: 21.069,
    transform: "translate(1130.916 601.159) rotate(-66.705)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.461,
    height: 21.069,
    transform: "translate(1139.679 625.258) rotate(-66.705)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.135,497.525l1.487,70.639,45.73,24.167,83.28-14.872,2.045-73.428-52.794-18.59Z",
    transform: "translate(484.634 179.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.6,727.276l-46.332-24.484-1.51-71.711,80.563-12.207.172.06,53.3,18.767-2.076,74.555ZM554.705,701.9l45.128,23.848,82.448-14.723,2.013-72.3-52.12-18.352-78.935,11.96Z",
    transform: "translate(324.272 45.753)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.3,517.823l-.179-.071-46.287-18.4.539-1.357,46.109,18.332,86.065-11.87.2,1.447Z",
    transform: "translate(484.661 178.79)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.461,
    height: 76.408,
    transform: "translate(922.326 695.877) rotate(-0.697)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.818,512.163l-12.644-5.1,80.324-12.8,12.643,5.1Z",
    transform: "translate(482.257 179.13)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.461,
    height: 21.069,
    transform: "translate(876.479 699.298) rotate(-66.705)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.461,
    height: 21.069,
    transform: "translate(885.242 723.397) rotate(-66.705)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.563,507.988l1.727,82,53.085,28.053,96.675-17.263,2.374-85.239-61.285-21.58Z",
    transform: "translate(476.652 179.158)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.587,753.1,640.8,724.676l-1.753-83.244,93.521-14.17.2.07,61.868,21.785-2.41,86.546Zm-52.11-29.456,52.387,27.684,95.709-17.091,2.337-83.931-60.5-21.3-91.63,13.883Z",
    transform: "translate(316.301 44.987)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.158,531.552l-.207-.083-53.733-21.363.626-1.576,53.525,21.281,99.907-13.779.232,1.679Z",
    transform: "translate(476.683 177.827)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.696,
    height: 88.698,
    transform: "translate(1009.1 708.524) rotate(-0.697)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.327,525.02l-15.537-5.96L603.033,504.2l15.538,5.96Z",
    transform: "translate(473.892 178.223)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.695,
    height: 24.458,
    transform: "translate(955.879 712.495) rotate(-66.705)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.695,
    height: 24.458,
    transform: "translate(966.051 740.469) rotate(-66.705)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.874,534.047a8.521,8.521,0,0,0,3.338-12.631l10.379-16.475-8.473-8.749-14.331,23.471a8.567,8.567,0,0,0,9.087,14.385Z",
    transform: "translate(297.258 56.954)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.548,423.508l-7.436-4.9s-5.738,1.287-11.841,13.025-30.714,64.219-30.714,64.219l10.117,10.268,26.988-41.172Z",
    transform: "translate(295.986 64.038)",
    fill: "#3f3d56"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgECommerce);
export default __webpack_public_path__ + "static/media/e-commerce.eca33a7346d5f2eaec448b0a60997910.svg";
export { ForwardRef as ReactComponent };